import { Button, Modal, Select, Typography } from 'antd'
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react'
import { FlightModalAPI } from '../../API/FlightModalAPI';
import { useFetchers } from 'react-router-dom';
import { useFlightModel } from '../../contexts/FlightModelContext';
const { Text } = Typography;

export const SelectFlightModal = ({ open, setOpen, flightModalOptions, selectedModal, messageToast }) => {
    const INITIAL_OBJECT = {
        flightModal: null,
        errorFieds: {
            flightModal: '',
        }
    }

    const [inputElements, setInputElements] = useState({ ...INITIAL_OBJECT });
    const [btnLoading, setBtnLoading] = useState(false);
    const { setSelectedFlightModel } = useFlightModel();

    function cancelFun() {
        setInputElements(INITIAL_OBJECT)
        setOpen(false)
    }

    async function applyFun() {
        if (inputElements.flightModal) {
            setBtnLoading(true)
            const bodyData = {
                "flight_model": inputElements.flightModal
            }
            await FlightModalAPI.saveFlightModal(bodyData)
                .then(res => {
                    if (res.data?.status === true) {
                        setOpen(false);
                        setInputElements({ ...INITIAL_OBJECT });
                         
                        // localStorage.setItem("flight_model", res?.data?.selected_flight_model)
                         const selectedModel = res?.data?.selected_flight_model;
                         setSelectedFlightModel(selectedModel);
                        
                        messageToast("success", res.data?.message)
                        window.location.reload()
                    } else {
                        messageToast("error", res.data?.message)
                    }
                })
                .catch(() => messageToast("error", "Internal Server Error"))
                .finally(() => {
                    setOpen(false);
                    setBtnLoading(false)
                })

        } else {
            setInputElements((prev) => ({
                ...prev,
                errorFieds: {
                    ...prev.errorFieds,
                    flightModal: 'Please select a flight model'
                }
            }))
        }
    }

    useEffect(() => {
        if (open) {
            setInputElements(prev => ({ ...prev, flightModal: selectedModal }))
        }
    }, [open])

    return (
        <Modal
            open={open}
            onCancel={() => cancelFun()}
            footer={[
                <Button key="back" type='text' onClick={cancelFun}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={applyFun}
                    loading={btnLoading}
                >
                    Apply
                </Button>,
            ]}
        >
            <div style={{ padding: '10px' }}>
                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                    <Title level={5}>Select Flight Model</Title>
                </div>

                <div style={{ marginBottom: '15px' }}>
                    <label>Flight Model</label>
                    <Select
                        tatus={!inputElements.errorFieds.flightModal ? '' : 'error'}
                        style={{
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '5px'
                        }}
                        value={inputElements.flightModal}
                        onChange={(e) => {
                            const value = e;

                            setInputElements((prev) => ({
                                ...prev,
                                flightModal: value,
                                errorFieds: {
                                    ...prev.errorFieds,
                                    flightModal: !value ? 'Please select a flight model' : ""
                                }
                            }));
                        }}
                        options={flightModalOptions}
                    />
                    <Text type="danger" italic>{inputElements.errorFieds.flightModal}</Text>
                </div>
            </div>
        </Modal>
    )
}
